import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { Divider, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material';
import React from 'react';
export const SectionListItemButton = (props) => {
    var _a, _b;
    const ListItemDivider = () => React.createElement(Divider, { sx: { width: 'inherit' } });
    return (React.createElement(ListItem, { disablePadding: true, sx: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
        } },
        props.showTopDivider && React.createElement(ListItemDivider, null),
        React.createElement(ListItemButton, { sx: {
                '&:focus-visible': {
                    outline: '1px solid ' + themeColors.primary.border,
                    backgroundColor: themeColors.surface.hover,
                },
                '&:hover': { outline: '1px solid ' + themeColors.primary.border, backgroundColor: themeColors.surface.hover },
                width: 'inherit',
            }, onClick: props.onClick },
            React.createElement(ListItemText, { primary: React.createElement(Typography, null, props.primaryText), secondary: (_a = props.secondaryText) !== null && _a !== void 0 ? _a : null, "data-test": (_b = props['data-test']) !== null && _b !== void 0 ? _b : undefined, "data-test-section-name": props['data-test-section-name'] }),
            React.createElement(ChevronRight, null)),
        React.createElement(ListItemDivider, null)));
};
